const PASSWORD_RULES = [
  { test: (p) => p.length >= 8, message: 'At least 8 characters' },
  { test: (p) => /[A-Z]/.test(p), message: 'One uppercase letter' },
  { test: (p) => /[a-z]/.test(p), message: 'One lowercase letter' },
  { test: (p) => /[0-9]/.test(p), message: 'One number' },
  { test: (p) => /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/~`]/.test(p), message: 'One special character' },
];

export function validatePassword(password) {
  const failures = PASSWORD_RULES.filter((r) => !r.test(password));
  return { valid: failures.length === 0, failures };
}

export { PASSWORD_RULES };
